import { memo } from "react";

// Libraries
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { MdOutlineHome } from "react-icons/md";
// Components
import FooterMenu, { Footer } from "./Footer";

// Data
import FooterData from "./FooterData";

const FooterStyle04 = (props) => {
  return (
    <Footer
      topSpace={false}
      theme={props.theme}
      className={`footer-style-04 ${
        props.className ? ` ${props.className}` : ""
      }`}
    >
      <div className="py-[1%] lg:py-[8%] md:py-[50px]">
        <Container>
          <Row className="items-center">
            <Col lg={2} md={4} sm={6} className="mb-[25px] sm:mb-0">
              <Link
                aria-label="link"
                to="/"
                className="flex gap-1 rounded-md border-1 justify-center p-2 items-center text-[25px]"
              >
                <MdOutlineHome className="text-[30px]" /> Home
              </Link>
            </Col>
            <div className="flex sm:flex-col flex-wrap justify-center gap-[40px]">
              <FooterMenu
                data={FooterData}
                className="mb-[25px] sm:mb-0"
                titleClass="capitalize"
              />
            </div>
          </Row>
          <div className="flex justify-center mt-8">
            <p>
              &copy; Copyright {new Date().getFullYear()}{" "}
              <Link
                aria-label="link"
                to="/"
                rel="noreferrer"
                className="underline underline-offset-4 font-medium hover:text-themecolor"
              >
                KERA
              </Link>
            </p>
          </div>
        </Container>
      </div>
    </Footer>
  );
};

FooterStyle04.defaultProps = {
  data: FooterData,
  logo: "/assets/img/webp/logo-fast-blue-black.webp",
};

FooterStyle04.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};

export default memo(FooterStyle04);
